import {
  SAVE_SHAPES_FINISHED,
  INVALID_SHAPE,
  UPDATE_TOTAL_EXTERIOR_CORNERS,
  UPDATE_TOTAL_INTERIOR_CORNERS,
  LOAD_SHAPE_INFO_FROM_CONFIGURATION,
  UPDATE_INITIAL_LOAD,
} from '../actions/actionTypes';

const initialState = {
  shapeRotation: 0,
  shapes: [],
  isValid: true,
  messages: {},
  initialLoad: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case INVALID_SHAPE: {
    return {
      ...state,
      isValid: action.isValid,
      messages: action.messages,
    };
  }

  case SAVE_SHAPES_FINISHED: {
    return {
      ...state,
      shapes: action.payload.shapes,
      areaChanged: action.payload.areaChanged,
      designClassification: action?.payload?.designClassification,
      isValid: true,
      messages: {},
    };
  }

  case LOAD_SHAPE_INFO_FROM_CONFIGURATION: {
    return { ...state, ...action.payload.draftingTool };
  }

  case UPDATE_TOTAL_EXTERIOR_CORNERS: {
    return { ...state, totalExteriorCorners: action.payload };
  }

  case UPDATE_TOTAL_INTERIOR_CORNERS: {
    return { ...state, totalInteriorCorners: action.payload };
  }
  case UPDATE_INITIAL_LOAD: {
    return { ...state, initialLoad: action.payload.initialLoad };
  }

  default:
    return state;
  }
};
